import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export function HeroCard({ title, metric, subMetrics = [], color = {} }) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 p-8 shadow-sm">
      <h2 className="text-sm font-semibold text-gray-600 dark:text-gray-400 mb-2">{title}</h2>
      <div className="text-4xl font-bold text-gray-900 dark:text-white mb-6">{metric}</div>
      {subMetrics.length > 0 && (
        <div className="grid grid-cols-3 gap-4">
          {subMetrics.map((sm, idx) => (
            <div key={idx} className="border-t border-gray-200 dark:border-slate-700 pt-3">
              <div className="text-xs text-gray-600 dark:text-gray-400 mb-1">{sm.label}</div>
              <div className="flex items-center gap-2">
                <span className="text-lg font-semibold text-gray-900 dark:text-white">{sm.value}</span>
                {sm.trend === 'up' && <TrendingUp className="w-4 h-4 text-green-600" />}
                {sm.trend === 'down' && <TrendingDown className="w-4 h-4 text-red-600" />}
                {sm.change && sm.trend && <span className="text-xs text-gray-500">{sm.change}%</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
